import _asyncToGenerator from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _regeneratorRuntime from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.regexp.match.js";
import "core-js/modules/es7.array.includes.js";
import axios from 'axios';
import { Model } from '@vuex-orm/core';
import Notify from 'quasar/src/plugins/Notify.js';;
import { first } from 'lodash';
import User from 'src/store/models/User';
export default /*#__PURE__*/(function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(context) {
    var token;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            context.Vue.prototype.$axios = axios.create({
              baseURL: process.env.API_URL
            });
            token = User.accessToken();

            if (token) {
              context.Vue.prototype.$axios.defaults.headers.common.Authorization = 'Bearer ' + token;
            }

            context.Vue.prototype.$axios.interceptors.response.use(function (response) {
              return response;
            }, /*#__PURE__*/function () {
              var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(error) {
                var originalRequest;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        if (!(!error.response || !!error.response.config.headers['x-prevent-notifications'])) {
                          _context.next = 2;
                          break;
                        }

                        return _context.abrupt("return", Promise.reject(error));

                      case 2:
                        if (!(error.response.status === 422)) {
                          _context.next = 10;
                          break;
                        }

                        if (!(error.response.data instanceof ArrayBuffer)) {
                          _context.next = 7;
                          break;
                        }

                        return _context.abrupt("return", Promise.reject(error));

                      case 7:
                        if (error.response.data.errors) {
                          Notify.create({
                            message: first(error.response.data.errors[first(Object.keys(error.response.data.errors))]),
                            type: 'negative'
                          });
                        } else if (error.response.data.message) {
                          Notify.create(error.response.data.message);
                        } else {
                          Notify.create('Something went wrong. Please try again.');
                        }

                      case 8:
                        _context.next = 23;
                        break;

                      case 10:
                        if (!(error.response.status === 403)) {
                          _context.next = 14;
                          break;
                        }

                        Notify.create(error.response.data.message);
                        _context.next = 23;
                        break;

                      case 14:
                        if (!(error.response.status === 401)) {
                          _context.next = 21;
                          break;
                        }

                        if (error.response.request.responseURL.match('login')) {
                          _context.next = 19;
                          break;
                        }

                        // Try to refresh the token and retry the request
                        originalRequest = error.config;
                        _context.next = 19;
                        return User.$refreshAccessToken(originalRequest);

                      case 19:
                        _context.next = 23;
                        break;

                      case 21:
                        if (!([303, 402, 412, 429].includes(error.response.status) || error.response.status === 400 && error.response.request.responseURL.match('login'))) {
                          _context.next = 23;
                          break;
                        }

                        return _context.abrupt("return", Promise.reject(error));

                      case 23:
                        return _context.abrupt("return", Promise.reject(error));

                      case 24:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x2) {
                return _ref2.apply(this, arguments);
              };
            }());
            Model.setAxios(context.Vue.prototype.$axios);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
})();